import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";

function buildRouteKey(pathname: string, search: string): string {
  return search ? `${pathname}${search}` : pathname;
}

/**
 * Feuert "virtual_page_view" bei Client-Side-Navigation (die SPA liefert dafür
 * keinen echten Page-Load). Bewusst NICHT beim ersten Mount, damit das initiale
 * PageView weiterhin ausschließlich vom nativen GTM-Container-Trigger (All Pages)
 * kommt -- sonst doppeltes Firing auf der ersten Seite. Der Ref wird direkt mit der
 * aktuellen Route initialisiert (statt eines simplen "erster Render"-Flags), weil
 * React 18 Strict Mode Effects im Dev-Modus einmalig doppelt ausführt -- ein reines
 * Flag würde dabei fälschlich auch beim ersten Laden pushen.
 *
 * Gleicher Ansatz/Eventname wie RouteChangeTracker.tsx in propora-web, siehe
 * TRACKING-CONSENT-IMMO-TOOLS.md Punkt 3.
 */
export function RouteChangeTracker() {
  const location = useLocation();
  const routeKey = buildRouteKey(location.pathname, location.search);
  const lastPushedRouteKey = useRef(routeKey);

  useEffect(() => {
    if (lastPushedRouteKey.current === routeKey) return;
    lastPushedRouteKey.current = routeKey;
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: "virtual_page_view",
      page_path: routeKey,
      page_location: window.location.href,
    });
  }, [routeKey]);

  return null;
}
